// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"23":"12a75e2112863903","58":"687689f3593c3d53","287":"085dddbe434b0909","346":"c6ae324be203c5f7","359":"0180a7a01a0ccb61","694":"21efe65555349403","893":"64736083ce4d3374","900":"a4650141cd99a610"}[chunkId] + ".js";
};